module.exports = __webpack_public_path__ + "e640d0eb5529007076cb7b46e10d1d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar_Eco8_grau@2x.png
// module id = 257
// module chunks = 0